<template>
    <footer class="footer" role="contentinfo">
        <div class="footer__container container-wide">
            <nav class="footer__primary-nav">
                <h2 class="visuallyhidden">Primary Footer Navigation</h2>
                <ul class="footer__primary-links">
                    <li v-show="!$page.props.auth.user">
                        <Link :href="route('login')">Log In</Link>
                    </li>
                    <li><Link :href="route('explore')">Gift Ideas</Link></li>
                    <li><Link :href="route('about-us')">About</Link></li>
                    <li>
                        <a
                            href="https://support.gifthero.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            >Help</a
                        >
                    </li>
                    <li>
                        <Link :href="route('browser-extensions')"
                            >Browser Extension</Link
                        >
                    </li>
                    <li><Link :href="route('mobile')">Mobile App</Link></li>
                    <li>
                        <a :href="route('gift-cards')">Gift Cards</a>
                    </li>
                </ul>
                <!-- .footer__primary-links -->
            </nav>
            <!-- .footer__primary-nav -->
            <nav class="footer__secondary-nav">
                <h2 class="visuallyhidden">Secondary Footer Navigation</h2>
                <ul class="footer__secondary-links">
                    <li>
                        <Link :href="route('policy.show')">Privacy Policy</Link>
                    </li>
                    <li>
                        <Link :href="route('terms.show')">Terms of Use</Link>
                    </li>
                    <li><Link :href="route('contact-us')">Contact</Link></li>
                </ul>
                <!-- .footer__secondary-links -->
            </nav>
            <!-- .footer__secondary-nav -->
            <div class="footer__social">
                <ul class="footer__social-links">
                    <li>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Gift Hero on Facebook"
                            :href="$page.props.socialLinks.facebook"
                        >
                            <SvgFacebook />
                        </a>
                    </li>
                    <li>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Gift Hero on Pinterest"
                            :href="$page.props.socialLinks.pinterest"
                        >
                            <SvgPinterest />
                        </a>
                    </li>
                    <li>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Gift Hero on Twitter"
                            :href="$page.props.socialLinks.twitter"
                        >
                            <SvgTwitter />
                        </a>
                    </li>
                    <li>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Gift Hero on Instagram"
                            :href="$page.props.socialLinks.instagram"
                        >
                            <SvgInstagram />
                        </a>
                    </li>
                    <li>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Gift Hero on Medium.com"
                            :href="$page.props.socialLinks.medium"
                        >
                            <SvgMedium />
                        </a>
                    </li>
                </ul>
                <!-- .footer__social-links -->
            </div>
            <!-- .footer__social -->
            <div class="footer__copyright">
                &copy; {{ new Date().getFullYear() }} Gift Hero Inc. All Rights
                Reserved
            </div>
        </div>
        <!-- .footer__container -->
    </footer>
    <!-- .footer -->
</template>

<script setup>
import SvgFacebook from "~/svg/social-facebook.svg";
import SvgInstagram from "~/svg/social-instagram.svg";
import SvgPinterest from "~/svg/social-pinterest.svg";
import SvgMedium from "~/svg/social-medium.svg";
import SvgTwitter from "~/svg/social-twitter.svg";
import { Link } from "@inertiajs/vue3";
</script>
